import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://90484273737835978cecbf8a7c909a28@o4509191637762048.ingest.de.sentry.io/4509315229483088',
  sendDefaultPii: true,
});
